<template>
  <div class="home">
    <el-carousel :interval="5000" arrow="always" height="400px">
      <el-carousel-item v-for="(item, index) in list_img" :key="index">
        <img :src="item.url" alt />
      </el-carousel-item>
    </el-carousel>
    <div class="info">
      <h3>成立背景</h3>
      <span
        ><font style="font-weight: 600;">永新科技（YONGXIN）</font>，我们是您在信息技术和广告服务领域的创新合作伙伴。<br>
        我们成立于 2023年初，总部位于中国香港, 专注于提供尖端 IT解决方案和广告智能营销。<br>
        我们的专家团队致力于提供满足每个客户独特需求的定制解决方案，从开发强大的网站和应用程序到执行全面的数字营销活动，<br>
        满足企业的数字化、智能化需求，帮助客户创造、提升价值，与客户共同成长。<br>
        我们的核心服务包括但不限于：<br>
        <font style="font-weight: 600;">IT 支持和咨询：</font>提供可靠的 IT支持和战略咨询，帮助企业应对技术挑战。<br>
        <font style="font-weight: 600;">移动应用开发：</font>设计和开发吸引用户并简化运营的创新移动应用程序。<br>
        <font style="font-weight: 600;">数字营销：</font>实施有效的策略，包括SEO、PPC、社交媒体营销和内容创建，以提高您的在线知名度。<br>
      </span>
      <div class="firstAlbum">
        <div
          v-for="(item, index) in firstAlbum"
          :key="index"
          :style="{ marginLeft: index == 0 ? '0px' : '80px' }"
        >
          <img
            :src="item.url"
            alt
            style="width:200px;height:200px;margin-top: 50px;margin-bottom: 30px;"
          />
          <span
            style="font-size:1.125rem;line-height:1.75rem;color: #1A1A1A;font-weight: 600;text-align: center;display: block;margin-bottom:1.0625rem"
            >{{ item.title }}</span
          >
          <div
            v-html="item.desc"
            style="line-height:1.375rem;font-size:14px;color:#777777"
          ></div>
        </div>
      </div>
    </div>

    <div
      style="background-color:#E6F0FB; padding-bottom: 53px;text-align: center;"
    >
      <h3>团队力量</h3>
      <li
        style="display: contents;text-align: left;width:max-content;background-color: aqua;line-height:24pt;"
      >
        <img
          :src="require('../assets/power.png')"
          alt
          style="vertical-align: middle;width:340px;height:217px;margin-right:51px ;"
        />
        <span style="display: inline-block;vertical-align: middle;"
          >公司团队由一批业界资深的专业人士组成，<br>
          大部分成员曾就职于各大领尖互联网公司。<br>
          我们的目标专注深耕全球市场，战略伙伴网络遍布全球，<br>
          拥有上亿用户流量，利用强大的资源整合能力为客户实现共赢。</span
        >
      </li>
    </div>

    <div>
      <h3>企业愿景</h3>
      <span
        >我们的使命是弥合技术与创意之间的差距，为客户创造更高价值</span
      >
      <div>
        <img
          v-for="(item, index) in secondAlbum"
          :key="index"
          :src="item.url"
          alt
          style="width:360px;height:220px;margin-top: 50px;margin-bottom: 50px; margin-left: 22px;margin-right: 22px;"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: "公司简介",
      list_img: [
        { url: require("../assets/banner.png") },
        { url: require("../assets/banner.png") }
      ],
      firstAlbum: [
        {
          url: require("../assets/album01/album01_0.png"),
          title: "开放进取",
          desc: "主动担当，积极主动<br/>拥抱变化，善于创新"
        },
        {
          url: require("../assets/album01/album01_1.png"),
          title: "诚信为先",
          desc:
            "用户至上，以产品为核心<br/>专业的团队做专业的事，<br/>打造富有生命力的海外产品矩阵"
        },
        {
          url: require("../assets/album01/album01_2.png"),
          title: "合作共赢",
          desc:
            "以优质的产品与用户共创价值，<br/>以实现员工与合作伙伴的<br/>理想为己任"
        },
        {
          url: require("../assets/album01/album01_3.png"),
          title: "追求卓越",
          desc: "孵化梦想，成就专业<br/>深度思考，快速执行"
        }
      ],
      secondAlbum: [
        { url: require("../assets/album02/album02_0.png") },
        { url: require("../assets/album02/album02_1.png") },
        { url: require("../assets/album02/album02_2.png") }
      ]
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home {
  text-align: center;
  padding: 0;
  margin: 0;
  min-height: 100%;
}
.info {
  width: 100%;
  text-align: center;
  align-items: center;
  padding: 0;
  margin: 0;
  padding-bottom: 53px;
}

h3 {
  font-size: 24px;
  line-height: 36px;
  padding-top: 50px;
  color: #1a1a1a;
  padding-bottom: 38px;
}
span {
  line-height: 1.375rem;
  font-size: 0.875rem;
  color: #777777;
}
.el-carousel__item {
  height: 400px;
}
.el-carousel__item img {
  width: 100%;
  height: 100%;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.small img {
  width: 100%;
  height: 100%;
}

.el-carousel__container {
  width: 100%;
  height: 460px;
}

.firstAlbum {
  position: relative;
  display: flex;
  flex-flow: row;
  flex-wrap: nowrap;
  justify-content: center;
  text-align: center;
  place-content: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue